<template>
  <div id="kalender-modal" class="modal fade">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="closeModal">&times;</button>
          <h4 class="modal-title">{{ $t("global.calendarofevents") }}</h4>
        </div>

        <div class="modal-body">
            <div class="calendar-wrapper">
                <div class="calendar-header d-flex justify-content-between align-items-center mb-2 pt-4">
                    <button class="arrow" @click="prevMonth" :disabled="isBeforeStartMonth">
                        <font-awesome-icon icon="fa-solid fa-arrow-left" />
                    </button>
                    <button class="arrow" @click="nextMonth" :disabled="isAfterEndMonth">
                        <font-awesome-icon icon="fa-solid fa-arrow-right" />
                    </button>
                </div>
                <div>
                    <h4 class="text-center">
                        {{
                        new Date(currentYear, currentMonth).toLocaleString(language || "de", {
                            month: "long",
                            year: "numeric",
                        })
                        }}
                    </h4>

                    <div class="calendar-grid">
                        <div class="day-name" v-for="day in days" :key="day">
                        {{ day }}
                        </div>

                        <div
                        v-for="(date, index) in getCalendarDays()"
                        :key="index"
                        :class="['day', date.klasse, 
                        { 
                            today: date.isToday,
                            'select-ends': date.date && isSelected(date.date),
                            'select-middle': date.date && isInRange(date.date),
                        }]"
                        @click="date.date && selectDate(date.date)"
                        >
                        <span class="dot"></span>
                        <span>{{ date.isCurrentMonth ? date.day : "" }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="closeModal">
            {{ $t("global.cancel") }}
          </button>
          <button type="button" class="btn btn-success" @click="saveSelection">
            {{ $t("global.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";

export default {
  name: "KalenderModal",
  props: {
    von: String,
    bis: String,
  },
  data() {
    return {
      shown: false,
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      language: null,
      selectedDates: [],
      zeitraum: null,
      vonLocal: null,
      bisLocal: null,
      selectedZeitraum: null,
      einsaetze: [],
    };
  },
  computed: {
    days() {
      switch (this.language) {
        case "en": return ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
        case "fr": return ["Lu", "Ma", "Me", "Je", "Ve", "Sa", "Di"];
        case "it": return ["Lu", "Ma", "Me", "Gi", "Ve", "Sa", "Do"];
        default: return ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
      }
    },
    monthName() {
      return new Date(this.currentYear, this.currentMonth).toLocaleString(this.language || "de", {
        month: "long",
      });
    },
    startLimit() {
      if (!this.von) return null;
      const parts = this.von.split(" ")[0].split(".");
      return new Date(parts.reverse().join("-"));
    },
    endLimit() {
      if (!this.bis) return null;
      const parts = this.bis.split(" ")[0].split(".");
      return new Date(parts.reverse().join("-"));
    },
    isBeforeStartMonth() {
      if (!this.startLimit) return false;

      const firstVisible = new Date(this.currentYear, this.currentMonth - 1, 1);
      const start = new Date(this.startLimit.getFullYear(), this.startLimit.getMonth(), 1);

      return firstVisible < start;
    },

    isAfterEndMonth() {
      if (!this.endLimit) return false;

      const lastVisible = new Date(this.currentYear, this.currentMonth + 1, 1);
      const end = new Date(this.endLimit.getFullYear(), this.endLimit.getMonth(), 1);

      return lastVisible > end;
    },

    selectedStart() {
      return this.selectedDates[0] || null;
    },
    selectedEnd() {
      return this.selectedDates[1] || this.selectedDates[0] || null;
    },


  },  

  mounted() {

    this.$bus.$on("open-kalender-modal", (payload) => {
      if (payload?.minDatum) {
        this.vonLocal = payload.minDatum;
        
        const startDate = this.parseDate(payload.minDatum);
        this.currentYear = startDate.getFullYear();
        this.currentMonth = startDate.getMonth();
      }
      if (payload?.maxDatum) this.bisLocal = payload.maxDatum;
      if (payload?.selectedZeitraum) this.selectedZeitraum = payload.selectedZeitraum;
      if (payload?.einsaetze) this.einsaetze = payload.einsaetze;

      console.log("einsaetze im KalenderModal:", this.einsaetze);

      if (!this.shown) this.openModal();
    });

    if (!this.startLimit || !this.endLimit) return;

    const today = new Date();

    if (today < this.startLimit) {
      this.currentYear = this.startLimit.getFullYear();
      this.currentMonth = this.startLimit.getMonth();
    } else if (today > this.endLimit) {
      this.currentYear = this.endLimit.getFullYear();
      this.currentMonth = this.endLimit.getMonth();
    }
  },
  methods: {
    openModal() {
      this.shown = true;
      $("#kalender-modal").modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.shown = false;
      $("#kalender-modal").modal("hide");
    },
    dateToGerman(date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${dd}.${mm}.${yyyy} 00:00:00`;
    },
    saveSelection() {
      if (!this.selectedStart || !this.selectedEnd) return;

      console.log("selectedZeitraum:", this.selectedZeitraum);


      const originalStart = this.normalizeDate(this.parseDate(this.vonLocal));
      const originalEnd = this.normalizeDate(this.parseDate(this.bisLocal));
      const removeStart = this.normalizeDate(this.selectedStart);
      const removeEnd = this.normalizeDate(this.selectedEnd);

      const diffInDaysBefore = (removeStart.getTime() - originalStart.getTime()) / (1000 * 60 * 60 * 24);
      const diffInDaysAfter = (originalEnd.getTime() - removeEnd.getTime()) / (1000 * 60 * 60 * 24);

      const startMonth = removeStart.getMonth();
      const endMonth = removeEnd.getMonth();
      const isJulyAugust = startMonth >= 6 && endMonth <= 7;
      const minDays = isJulyAugust ? 12 : 6;

      if (diffInDaysBefore > 0 && diffInDaysBefore < minDays) {
        this.$notify({ type: "error", title: this.$t("global.actionfailed"), text: this.$t("global.periodTooShort") });
        return;
      }
      if (diffInDaysAfter > 0 && diffInDaysAfter < minDays) {
        this.$notify({ type: "error", title: this.$t("global.actionfailed"), text: this.$t("global.periodTooShort") });
        return;
      }

      const zeitraeume = [];

      // Zeitraum vor der Pause
      if (removeStart > originalStart) {
        let beforeEnd = new Date(removeStart);
        beforeEnd.setDate(beforeEnd.getDate() - 1);
        beforeEnd = this.normalizeDate(beforeEnd);

        for (const einsatz of this.einsaetze) {
          if (!einsatz.von || !einsatz.bis) continue;
          const einsatzBis = this.normalizeDate(this.parseDate(einsatz.bis));
          const diff = (removeStart.getTime() - einsatzBis.getTime()) / (1000 * 60 * 60 * 24);
          if (diff > 0 && diff < minDays) {
            beforeEnd = einsatzBis;
            break;
          }
        }

        zeitraeume.push({
          angebot: this.selectedZeitraum.angebot,
          von: this.dateToGerman(originalStart),
          bis: this.dateToGerman(beforeEnd),
          einsatzplaetze: this.selectedZeitraum.einsatzplaetze,
        });
      }

      // Zeitraum nach der Pause
      if (removeEnd < originalEnd) {
        let afterStart = new Date(removeEnd);
        afterStart.setDate(afterStart.getDate() + 1);
        afterStart = this.normalizeDate(afterStart);

        for (const einsatz of this.einsaetze) {
          if (!einsatz.von || !einsatz.bis) continue;
          const einsatzVon = this.normalizeDate(this.parseDate(einsatz.von));
          const diff = (einsatzVon.getTime() - removeEnd.getTime()) / (1000 * 60 * 60 * 24);
          if (diff > 0 && diff < minDays) {
            afterStart = einsatzVon;
            break;
          }
        }

        zeitraeume.push({
          angebot: this.selectedZeitraum.angebot,
          von: this.dateToGerman(afterStart),
          bis: this.dateToGerman(originalEnd),
          einsatzplaetze: this.selectedZeitraum.einsatzplaetze,
        })
      }

      if (zeitraeume.length === 0) {
        console.log("zeitraeume vor API:", zeitraeume);
        this.$notify({
          type: "error",
          title: this.$t("global.actionunsuccessful"),
          text: this.$t("portal.periodTooShort"),
        });
        return;
      }

      console.log("zeitraeume vor API:", zeitraeume);

      AppApi.delete("zeitraum/", {
        data: [this.selectedZeitraum.id],
      })
        .then(() => {
          const requests = zeitraeume.map((z) => {
            console.log("POST payload:", JSON.stringify(z));  // <- was wird gesendet?
            return AppApi.post("zeitraum/", z, {
              params: { angebotId: this.selectedZeitraum.angebot },
            });
          });
          return Promise.all(requests);
        })
        .then((responses) => {
          // Belegungsstatus für jeden neuen Zeitraum vom Backend neu berechnen lassen
          const statusRequests = responses.map((res) =>
            AppApi.put("zeitraum/", null, {
              params: { zeitraumId: res.data.id },
            })
          );
          return Promise.all(statusRequests);
        })
        .then(() => {
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.successfullysaved"),
          });
          this.$bus.$emit("reload-zeitraeume");
          this.closeModal();
          this.$bus.$emit("reset-zeitraum-selection");
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: this.$t("global.actionfailed"),
            text: e.message,
          });
        });
    },
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
    },
    formatDate(date) {
      return date.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    getCalendarDays() {
      const year = this.currentYear;
      const month = this.currentMonth;
      const targetDate = new Date(year, month);
      const actualYear = targetDate.getFullYear();
      const actualMonth = targetDate.getMonth();

      const days = [];
      const firstDayOfMonth = new Date(actualYear, actualMonth, 1);
      const startDay = (firstDayOfMonth.getDay() + 6) % 7;
      const daysInMonth = new Date(actualYear, actualMonth + 1, 0).getDate();

      for (let i = 0; i < startDay; i++) {
        days.push({ day: "", isCurrentMonth: false, klasse: "", isToday: false });
      }

      const today = new Date();
      const todayKey = this.formatDate(today);

      for (let i = 1; i <= daysInMonth; i++) {
        const date = new Date(actualYear, actualMonth, i);
        const dateKey = this.formatDate(date);

        let klasse = "";

        if (this.vonLocal && this.bisLocal) {
          const current = this.normalizeDate(date);
          const start = this.normalizeDate(this.parseDate(this.vonLocal));
          const end = this.normalizeDate(this.parseDate(this.bisLocal));

          if (current < start || current > end) {
            klasse = "no-period";
          } else {
            const liegtInEinsatz = this.einsaetze.some(e => {
              if (!e.von || !e.bis) return false;
              const von = this.normalizeDate(this.parseDate(e.von));
              const bis = this.normalizeDate(this.parseDate(e.bis));
              return current >= von && current <= bis;
            });
            
            klasse = liegtInEinsatz ? "no-period" : "frei";
          }
        }        

        days.push({
          day: i,
          isCurrentMonth: true,
          isToday: dateKey === todayKey,
          klasse,
          date: date,
        });
      }

      return days;
    },

    parseDate(dateStr) {
      if (!dateStr) return null;
      if (dateStr instanceof Date) return dateStr;
      const parts = dateStr.split(".");
      // Format: dd.mm.yyyy
      return new Date(parts[2], parts[1] - 1, parts[0]);
    },    

    normalizeDate(date) {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    },

    selectDate(date) {
      if (!this.vonLocal || !this.bisLocal) return;

      const current = this.normalizeDate(date);
      const start = this.normalizeDate(this.parseDate(this.vonLocal));
      const end = this.normalizeDate(this.parseDate(this.bisLocal));

      const liegtInEinsatz = this.einsaetze.some(e => {
        if (!e.von || !e.bis) return false;
        const von = this.normalizeDate(this.parseDate(e.von));
        const bis = this.normalizeDate(this.parseDate(e.bis));
        return current >= von && current <= bis;
      });

      // Nur Tage innerhalb erlaubtem Zeitraum anklickbar
      if (current < start || current > end || liegtInEinsatz) return;

      // Toggle Auswahl
      if (
        this.selectedDates.length === 1 &&
        this.selectedDates[0]?.getTime() === current.getTime()
      ) {
        this.selectedDates = [];
        return;
      }

      if (this.selectedDates.length >= 2) {
        this.selectedDates = [current];
      } else {
        this.selectedDates.push(current);
      }

      this.selectedDates.sort((a, b) => a.getTime() - b.getTime());

      // Prüfen ob Auswahl Einsatz überspannt
      if (this.selectedDates.length === 2) {
        const selStart = this.selectedDates[0];
        const selEnd = this.selectedDates[1];

        const ueberspanntEinsatz = this.einsaetze.some(e => {
          if (!e.von || !e.bis) return false;
          const von = this.normalizeDate(this.parseDate(e.von));
          const bis = this.normalizeDate(this.parseDate(e.bis));
          return von > selStart && bis < selEnd || 
                 von >= selStart && von < selEnd ||
                 bis > selStart && bis <= selEnd;
        });

        if (ueberspanntEinsatz) {
          this.selectedDates = [current];
        }
      }

    },
    isSelected(date) {
      if (!date) return false;
      return (
        date.getTime() === this.selectedStart?.getTime() ||
        date.getTime() === this.selectedEnd?.getTime()
      );
    },

    isInRange(date) {
      if (!this.selectedStart || !this.selectedEnd) return false;
      return date > this.selectedStart && date < this.selectedEnd;
    },        
  },
};
</script>

<style lang="scss" scoped>
.calendar-wrapper {
  margin: 27px auto 54px;
  text-align: center;
  background: white;
  box-shadow: 0px 0px 10px 4px #c3c3c3;
  border-radius: 4px;
  height: 510px;
  width: 350px;
  padding: 24px 20px;

  h2 {
    font-weight: 700;
    font-size: 24px;
    padding-bottom: 16px;
  }

  .calendar-header {
    h3 {
      font-size: 16px;
    }

    button.arrow {
      background: none;
      border: none;
      font-size: 1.5rem;
      color: #c8eb24;
    }

    button.arrow:disabled {
      color: #cccccc;
    }
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;

    .day-name {
      font-weight: 600;
      font-size: 12px;
      padding-bottom: 5px;
      color: #808080;
    }

    .day {
      height: 40px;
      width: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 600;
      position: relative;

      &.other-month {
        color: #ccc;
      }

      &.no-period {
        color: #cccccc;
        text-decoration: line-through;
        pointer-events: none;
      }

      &.today {
        background: #007bff;
        color: white;
        border-radius: 50%;
      }

      &.frei:hover {
          cursor: pointer;
          &:not(.today):not(.select-ends):not(.select-middle) {
            background-color: rgb(236, 236, 236);
          }
      }
      &.select-ends {
        background-color: #373737;
        border-radius: 2px;
        color: white;
        text-decoration: line-through;
      }

      &.select-middle {
        background-color: #f8f4e9;
        border-radius: unset;
        text-decoration: line-through;

        &.today {
          color: #373737;
        }
      }      
    }
  }

  .dot {
    width: 4px;
    height: 4px;
    border-radius: 35%;
    position: absolute;
    top: 4px;
  }

  .voll .dot {
    background: #c92a4a;
  }

  .reserviert .dot {
    background: #ffa600;
  }

  .teilweise .dot {
    background: #49c420;
  }

  .frei .dot {
    background: none;
  }

  .no-period {
    color: #cccccc;
    text-decoration: line-through;
  }

  .kalender-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 16px;
    margin-top: 18px;
  }

  .kalender-header h2 {
    text-align: center;
  }
}
</style>
